import {configureStore} from '@reduxjs/toolkit';

// redux persist library
import {persistStore, persistReducer} from 'redux-persist';
import storage from 'redux-persist/lib/storage';

// reducers
import rootReducer from './combineReducers';

// api
import {rtkQueryErrorLogger} from 'services/middleware';
import {apiSlice} from 'services';

const persistConfig = {
	key: 'root',
	storage: storage,
	whitelist: ['user'],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
	reducer: persistedReducer,
	devTools: process.env.REACT_APP_ENVIRONMENT !== 'production',
	middleware: getDefaultMiddleware =>
		getDefaultMiddleware({
			immutableCheck: false,
			serializableCheck: false,
		}).concat(apiSlice.middleware, rtkQueryErrorLogger),
});

export const persistor = persistStore(store);
// type store
export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
